"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BooleanJN = _interopRequireDefault(require("./BooleanJN"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Auftragsdetails model module.
 * @module model/Auftragsdetails
 * @version 1.0.44
 */
var Auftragsdetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Auftragsdetails</code>.
   * zusätzliche Informationen zu einem Auftrag
   * @alias module:model/Auftragsdetails
   * @param mitarbeiterKz {module:model/BooleanJN} 
   * @param beratungKz {module:model/BooleanJN} 
   * @param kundenKonto {String} Kontonummer des Kunden (KONTO bzw KUNDE_KONTO)
   * @param konditionsAenderung {Number} Summe aus Provision und  rel. Konditionsänderung (PROV_REL_BETR bzw VORZEICHEN+KONDITION)
   */
  function Auftragsdetails(mitarbeiterKz, beratungKz, kundenKonto, konditionsAenderung) {
    _classCallCheck(this, Auftragsdetails);
    Auftragsdetails.initialize(this, mitarbeiterKz, beratungKz, kundenKonto, konditionsAenderung);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Auftragsdetails, null, [{
    key: "initialize",
    value: function initialize(obj, mitarbeiterKz, beratungKz, kundenKonto, konditionsAenderung) {
      obj['mitarbeiterKz'] = mitarbeiterKz;
      obj['beratungKz'] = beratungKz;
      obj['kundenKonto'] = kundenKonto;
      obj['konditionsAenderung'] = konditionsAenderung;
    }

    /**
     * Constructs a <code>Auftragsdetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Auftragsdetails} obj Optional instance to populate.
     * @return {module:model/Auftragsdetails} The populated <code>Auftragsdetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Auftragsdetails();
        if (data.hasOwnProperty('mitarbeiterKz')) {
          obj['mitarbeiterKz'] = _BooleanJN.default.constructFromObject(data['mitarbeiterKz']);
        }
        if (data.hasOwnProperty('beratungKz')) {
          obj['beratungKz'] = _BooleanJN.default.constructFromObject(data['beratungKz']);
        }
        if (data.hasOwnProperty('kundenKonto')) {
          obj['kundenKonto'] = _ApiClient.default.convertToType(data['kundenKonto'], 'String');
        }
        if (data.hasOwnProperty('kundenTelefon')) {
          obj['kundenTelefon'] = _ApiClient.default.convertToType(data['kundenTelefon'], 'String');
        }
        if (data.hasOwnProperty('auftragstext')) {
          obj['auftragstext'] = _ApiClient.default.convertToType(data['auftragstext'], 'String');
        }
        if (data.hasOwnProperty('konditionsAenderung')) {
          obj['konditionsAenderung'] = _ApiClient.default.convertToType(data['konditionsAenderung'], 'Number');
        }
        if (data.hasOwnProperty('provision')) {
          obj['provision'] = _ApiClient.default.convertToType(data['provision'], 'Number');
        }
        if (data.hasOwnProperty('reisezweckKz')) {
          obj['reisezweckKz'] = _BooleanJN.default.constructFromObject(data['reisezweckKz']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Auftragsdetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Auftragsdetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Auftragsdetails.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['kundenKonto'] && !(typeof data['kundenKonto'] === 'string' || data['kundenKonto'] instanceof String)) {
        throw new Error("Expected the field `kundenKonto` to be a primitive type in the JSON string but got " + data['kundenKonto']);
      }
      // ensure the json data is a string
      if (data['kundenTelefon'] && !(typeof data['kundenTelefon'] === 'string' || data['kundenTelefon'] instanceof String)) {
        throw new Error("Expected the field `kundenTelefon` to be a primitive type in the JSON string but got " + data['kundenTelefon']);
      }
      // ensure the json data is a string
      if (data['auftragstext'] && !(typeof data['auftragstext'] === 'string' || data['auftragstext'] instanceof String)) {
        throw new Error("Expected the field `auftragstext` to be a primitive type in the JSON string but got " + data['auftragstext']);
      }
      return true;
    }
  }]);
}();
Auftragsdetails.RequiredProperties = ["mitarbeiterKz", "beratungKz", "kundenKonto", "konditionsAenderung"];

/**
 * @member {module:model/BooleanJN} mitarbeiterKz
 */
Auftragsdetails.prototype['mitarbeiterKz'] = undefined;

/**
 * @member {module:model/BooleanJN} beratungKz
 */
Auftragsdetails.prototype['beratungKz'] = undefined;

/**
 * Kontonummer des Kunden (KONTO bzw KUNDE_KONTO)
 * @member {String} kundenKonto
 */
Auftragsdetails.prototype['kundenKonto'] = undefined;

/**
 * Kunden Telefonnumme (TEL_NR)
 * @member {String} kundenTelefon
 */
Auftragsdetails.prototype['kundenTelefon'] = undefined;

/**
 * Freitext, in dem der User beliebigen Text zur Order erfassen kann. (INFO_TEXT)
 * @member {String} auftragstext
 */
Auftragsdetails.prototype['auftragstext'] = undefined;

/**
 * Summe aus Provision und  rel. Konditionsänderung (PROV_REL_BETR bzw VORZEICHEN+KONDITION)
 * @member {Number} konditionsAenderung
 */
Auftragsdetails.prototype['konditionsAenderung'] = undefined;

/**
 * Provisionsbetrag pro Stück bei Edelmetall (EM_RT_PROV_BETR)
 * @member {Number} provision
 */
Auftragsdetails.prototype['provision'] = undefined;

/**
 * @member {module:model/BooleanJN} reisezweckKz
 */
Auftragsdetails.prototype['reisezweckKz'] = undefined;
var _default = exports.default = Auftragsdetails;